
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leit",
      function () {
        return require("private-next-pages/leit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leit"])
      });
    }
  